export enum EventType {
    All = 'ALL',
    Finance = 'FINANCE',
    TextNotification = 'TEXT_NOTIFICATION',
}

export enum EventLevelType {
    All = 'ALL',
    Finance = 'FINANCE',
    Text = 'TEXT',
}
export type Notification = {
    date: string;
    deeplink?: string;
    eventType: EventType;
    id: number;
    parameters: {
        title: string;
        text: string;
    }
    processStarted: boolean;
    unread: boolean;
};
